'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _step_border = require('./step_border');

var _step_border2 = _interopRequireDefault(_step_border);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepContent = function (_React$Component) {
  (0, _inherits3.default)(StepContent, _React$Component);

  function StepContent() {
    (0, _classCallCheck3.default)(this, StepContent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(StepContent).apply(this, arguments));
  }

  (0, _createClass3.default)(StepContent, [{
    key: 'getDimensions',
    value: function getDimensions() {
      var container = this.refs.container;

      var width = 0;
      var height = 0;
      if (container) {
        width = container.clientWidth;
        height = container.clientHeight;
      }

      return { width: width, height: height };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var isLastChild = _props.isLastChild;

      return _react2.default.createElement(
        'div',
        { className: 'mdl-step__content', ref: 'container' },
        !isLastChild ? _react2.default.createElement(_step_border2.default, { contentHeight: this.getDimensions().height }) : null,
        children
      );
    }
  }]);
  return StepContent;
}(_react2.default.Component);

exports.default = StepContent;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-stepper/dist/step_content.js
// module id = 358
// module chunks = 0